// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Scalars = require("../../../scalars/Scalars.bs.js");
let TanDate = require("../../../reason/common/types/TanDate.bs.js");
let UTCDate = require("../../../reason/common/types/UTCDate.bs.js");
let DateFns = require("date-fns");
let DateFnsTz = require("../../../reason/common/DateFns/DateFnsTz.bs.js");
let Stdlib_Array = require("@rescript/runtime/lib/js/Stdlib_Array.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let ListingDetails = require("../../common/Components/ListingDetails.bs.js");
let Stdlib_Ordering = require("@rescript/runtime/lib/js/Stdlib_Ordering.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let PropertyParkingInfo = require("../../common/Property/PropertyParkingInfo.bs.js");
let Property__Components = require("../../../reason/clients/components/Property/Property__Components.bs.js");
let MlsPlanListingDetails = require("./MlsPlanListingDetails.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let PropertyWizardRelay__Preview__Shared = require("./PropertyWizardRelay__Preview__Shared.bs.js");
let PropertyWizardFormRelay__Validators__MLSTiming = require("./PropertyWizardFormRelay__Validators__MLSTiming.bs.js");
let PropertyWizardFormRelay__Validators__Description = require("./PropertyWizardFormRelay__Validators__Description.bs.js");
let PropertyWizardRelayPreviewListingDetails_formState_graphql = require("../../../__generated__/PropertyWizardRelayPreviewListingDetails_formState_graphql.bs.js");
let PropertyWizardRelayPreviewListingDetails_localDraft_graphql = require("../../../__generated__/PropertyWizardRelayPreviewListingDetails_localDraft_graphql.bs.js");
let PropertyWizardRelayPreviewListingDetails_previewHelpers_graphql = require("../../../__generated__/PropertyWizardRelayPreviewListingDetails_previewHelpers_graphql.bs.js");

let convertFragment = PropertyWizardRelayPreviewListingDetails_localDraft_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardRelayPreviewListingDetails_localDraft_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardRelayPreviewListingDetails_localDraft_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardRelayPreviewListingDetails_localDraft_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardRelayPreviewListingDetails_localDraft_graphql.node, convertFragment, fRef);
}

let DraftFragment_localDraftPropertyType_decode = PropertyWizardRelayPreviewListingDetails_localDraft_graphql.Utils.localDraftPropertyType_decode;

let DraftFragment_localDraftPropertyType_fromString = PropertyWizardRelayPreviewListingDetails_localDraft_graphql.Utils.localDraftPropertyType_fromString;

let DraftFragment = {
  localDraftPropertyType_decode: DraftFragment_localDraftPropertyType_decode,
  localDraftPropertyType_fromString: DraftFragment_localDraftPropertyType_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

let convertFragment$1 = PropertyWizardRelayPreviewListingDetails_previewHelpers_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardRelayPreviewListingDetails_previewHelpers_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardRelayPreviewListingDetails_previewHelpers_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardRelayPreviewListingDetails_previewHelpers_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardRelayPreviewListingDetails_previewHelpers_graphql.node, convertFragment$1, fRef);
}

let DisplayHelpersFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

let convertFragment$2 = PropertyWizardRelayPreviewListingDetails_formState_graphql.Internal.convertFragment;

function waitForFragmentData$2(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardRelayPreviewListingDetails_formState_graphql.node, convertFragment$2, fRef);
}

function use$2(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardRelayPreviewListingDetails_formState_graphql.node, convertFragment$2, fRef);
}

function useOpt$2(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardRelayPreviewListingDetails_formState_graphql.node, convertFragment$2);
}

function readResolverFragment$2(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardRelayPreviewListingDetails_formState_graphql.node, convertFragment$2, fRef);
}

let FormStateFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$2,
  waitForFragmentData: waitForFragmentData$2,
  use: use$2,
  useOpt: useOpt$2,
  readResolverFragment: readResolverFragment$2
};

function PropertyWizardRelay__Preview__ListingDetails$Display(props) {
  let websiteOverride = props.websiteOverride;
  let expectedOnMlsOverride = props.expectedOnMlsOverride;
  let timezone = props.timezone;
  let displayHelpers = RescriptRelay_Fragment.useFragment(PropertyWizardRelayPreviewListingDetails_previewHelpers_graphql.node, convertFragment$1, props.previewHelpers);
  let match = displayHelpers.showings;
  let tmp;
  if (match !== undefined && props.propertyType === "FOR_SALE" && timezone !== undefined) {
    let arr = Stdlib_Array.keepSome(match).filter(showing => DateFns.isAfter(UTCDate.toUnzonedDate(Scalars.DateTime.toUTC(showing.startDate)), TanDate.now())).slice();
    tmp = Stdlib_Option.getOr(Stdlib_Option.map((arr.sort((a, b) => Stdlib_Ordering.fromInt(UTCDate.toUnzonedDate(Scalars.DateTime.toUTC(a.startDate)).getTime() - UTCDate.toUnzonedDate(Scalars.DateTime.toUTC(b.startDate)).getTime() | 0)), arr)[0], showing => DateFns.format(UTCDate.toZonedDate(Scalars.DateTime.toUTC(showing.startDate), DateFnsTz.Timezone.make(timezone)), "MMM d 'at' h:mm a")), "None scheduled");
  } else {
    tmp = undefined;
  }
  let nextShowing = Stdlib_Option.map(tmp, prim => prim);
  let match$1 = MlsPlanListingDetails.useOpt(Stdlib_Option.map(displayHelpers.mlsPlan, mlsPlan => mlsPlan.fragmentRefs));
  let expectedOnMls = expectedOnMlsOverride !== undefined ? expectedOnMlsOverride : match$1[0];
  let website = websiteOverride !== undefined ? websiteOverride : Stdlib_Option.map(Stdlib_Option.map(displayHelpers.website, Scalars.URL.toString), website => JsxRuntime.jsx("a", {
      children: website,
      href: website,
      target: "_blank"
    }));
  let match$2 = displayHelpers.condoProperty;
  let match$3 = match$2 !== undefined ? [
      match$2.parkingSpaces,
      match$2.parkingDetails
    ] : [
      undefined,
      undefined
    ];
  let parkingValues = PropertyParkingInfo.ListingDetails.make(true, match$3[0], match$3[1]);
  let commission = Stdlib_Option.map(props.commission, prim => prim);
  return JsxRuntime.jsx(ListingDetails.make, {
    timeOnTan: "-",
    commission: commission,
    parkingSpots: parkingValues.parkingSpots,
    parkingDetails: parkingValues.parkingDetails,
    website: website,
    nextShowing: nextShowing,
    expectedOnMls: expectedOnMls,
    willShowBeforeMls: match$1[1],
    willAcceptOffersBeforeMls: match$1[2]
  });
}

let Display = {
  make: PropertyWizardRelay__Preview__ListingDetails$Display
};

function PropertyWizardRelay__Preview__ListingDetails(props) {
  let onEditForm = props.onEditForm;
  let draft = RescriptRelay_Fragment.useFragment(PropertyWizardRelayPreviewListingDetails_localDraft_graphql.node, convertFragment, props.draft);
  let formState = RescriptRelay_Fragment.useFragment(PropertyWizardRelayPreviewListingDetails_formState_graphql.node, convertFragment$2, props.formState);
  let websiteValid = PropertyWizardFormRelay__Validators__Description.Website.useIsValid(draft.fragmentRefs);
  let onMlsAtValid = PropertyWizardFormRelay__Validators__MLSTiming.OnMLSAt.useIsValid(draft.fragmentRefs, formState.fragmentRefs);
  let mlsListingTypeValid = PropertyWizardFormRelay__Validators__MLSTiming.MLSListingType.useIsValid(draft.fragmentRefs, formState.fragmentRefs);
  let mlsPreviewErrorMessages = PropertyWizardRelay__Preview__Shared.getMlsPreviewErrorMessages(mlsListingTypeValid, onMlsAtValid, onEditForm);
  let websiteOverride = typeof websiteValid === "object" && websiteValid.NAME === "Error" ? JsxRuntime.jsx(Property__Components.MissingFieldMarker.make, {
      text: "Please enter a valid URL",
      onClick: param => onEditForm("description")
    }) : undefined;
  return JsxRuntime.jsx(PropertyWizardRelay__Preview__ListingDetails$Display, {
    previewHelpers: props.previewHelpers,
    propertyType: draft.draftProperty.propertyType,
    timezone: draft.timeZone,
    commission: draft.draftProperty.commission,
    expectedOnMlsOverride: mlsPreviewErrorMessages,
    websiteOverride: websiteOverride
  });
}

let Validators;

let ListingDetails$1;

let MissingFieldMarker;

let Shared;

let make = PropertyWizardRelay__Preview__ListingDetails;

exports.Validators = Validators;
exports.ListingDetails = ListingDetails$1;
exports.MissingFieldMarker = MissingFieldMarker;
exports.Shared = Shared;
exports.DraftFragment = DraftFragment;
exports.DisplayHelpersFragment = DisplayHelpersFragment;
exports.FormStateFragment = FormStateFragment;
exports.Display = Display;
exports.make = make;
/* Scalars Not a pure module */
